import _ from "lodash";

// Parity with legacy set-alerts implementation (bottom-right single alert replacement)
// alertType values: danger | warning | info | success
export function setAlerts(alertType: "danger" | "warning" | "info" | "success", alertMessage: string) {
  const placeholder = document.getElementById("alerts-placeholder");
  if (!placeholder) { console.warn("alerts-placeholder not found"); return; }
  placeholder.innerHTML = `
    <div class="alert alert-${alertType} alert-dismissible fade show" role="alert" style="box-shadow: 0 6px 10px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)">
      <strong>${_.capitalize(alertType)}! </strong>${alertMessage}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  `;
}